import React from 'react';
import { MotorFlowType, MotorStepType } from 'scenes/motor/types';
import { stepOrder } from '../../helpers/progress';
import ProgressItem from './ProgressItem';
import { ProgressTrack } from './ProgressTrack';
import {
  calculateCarDetailsProgress,
  calculatePhraseProgress,
  isFlowCompleted,
  phraseDetector,
} from './utils';

interface MotorPreQuoteProps {
  flow: MotorFlowType;
  step: MotorStepType;
}

export const MotorPreQuote = ({ flow, step }: MotorPreQuoteProps) => {
  const currentlyInFlow = phraseDetector(flow, step);
  const checkFlowCompleted = isFlowCompleted(flow, step);

  return (
    <>
      <ProgressItem
        flowNumber={1}
        flowName="Car Details"
        isCurrentFlow={currentlyInFlow(stepOrder.slice(0, 5), [
          MotorFlowType.QuoteDetails,
        ])}
        isFlowComplete={checkFlowCompleted(
          MotorStepType.GenderAndDateOfBirth,
          MotorFlowType.AddDriver
        )}
      />
      <ProgressTrack
        progress={
          checkFlowCompleted(
            MotorStepType.GenderAndDateOfBirth,
            MotorFlowType.AddDriver
          )
            ? 100
            : calculateCarDetailsProgress(step)
        }
      />
      <ProgressItem
        flowNumber={2}
        flowName="Driver Details"
        isCurrentFlow={currentlyInFlow(stepOrder.slice(5, 9), [
          MotorFlowType.QuoteDetails,
        ])}
        isFlowComplete={checkFlowCompleted(
          MotorStepType.RecentInsurer,
          MotorFlowType.AddDriver
        )}
      />
      <ProgressTrack
        progress={
          checkFlowCompleted(
            MotorStepType.RecentInsurer,
            MotorFlowType.AddDriver
          )
            ? 100
            : calculatePhraseProgress(step, stepOrder.slice(5, 9))
        }
      />
      <ProgressItem
        flowNumber={3}
        flowName="Car Usage"
        isCurrentFlow={currentlyInFlow(stepOrder.slice(9, 14), [
          MotorFlowType.QuoteDetails,
        ])}
        isFlowComplete={checkFlowCompleted(
          MotorStepType.AddDriver,
          MotorFlowType.AddDriver
        )}
      />
      <ProgressTrack
        progress={
          checkFlowCompleted(MotorStepType.AddDriver, MotorFlowType.AddDriver)
            ? 100
            : calculatePhraseProgress(step, stepOrder.slice(9, 14))
        }
      />
      <ProgressItem
        flowNumber={4}
        flowName="Other Details"
        isCurrentFlow={
          currentlyInFlow(stepOrder.slice(14, 18), [
            MotorFlowType.QuoteDetails,
          ]) ||
          currentlyInFlow(stepOrder.slice(4, 7), [MotorFlowType.AddDriver])
        }
        isFlowComplete={checkFlowCompleted(MotorStepType.QuotePrice)}
      />
      <ProgressTrack
        progress={
          checkFlowCompleted(MotorStepType.QuotePrice)
            ? 100
            : calculatePhraseProgress(step, stepOrder.slice(14, 18))
        }
      />
      <ProgressItem
        flowNumber={5}
        flowName="Quote"
        isCurrentFlow={currentlyInFlow(
          [MotorStepType.QuotePrice],
          [MotorFlowType.CoverOptions]
        )}
        isFlowComplete={false}
      />
      <ProgressTrack
        width={25}
        progress={
          currentlyInFlow(
            [MotorStepType.QuotePrice],
            [MotorFlowType.CoverOptions]
          )
            ? 60
            : 0
        }
      />
    </>
  );
};
